import { Box, Theme } from '@mui/material';
import { FC, forwardRef } from 'react';
import { DropzoneRootProps } from 'react-dropzone';

type StateProps = {
  isDragAccept: boolean;
  isDragReject: boolean;
  isFocused: boolean;
};

type OwnProps = { disabled?: boolean; dropRejected?: boolean };

type Props = DropzoneRootProps & StateProps & OwnProps & { width?: string; height?: string };

export const Dropzone: FC<Props> = forwardRef((props, ref) => {
  return (
    <Box
      ref={ref}
      {...props}
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: props.width || '100px',
        height: props.height || '80px',
        padding: '20px 50px',
        borderRadius: '8px',
        borderWidth: '1px',
        borderStyle: 'dashed',
        borderColor: getColor(props, theme),
        backgroundColor: 'white',
        cursor: props.disabled ? 'not-allowed' : 'pointer'
      })}
      className="dropzone"
    />
  );
});

const getColor = (props: StateProps & OwnProps, theme: Theme) => {
  if (props.isDragAccept) {
    return theme.palette.success.main;
  }
  if (props.isDragReject || props.dropRejected) {
    return theme.palette.error.main;
  }
  if (props.isFocused) {
    return theme.palette.grey[900];
  }

  return theme.palette.grey[100];
};
